import { Select } from '@economic/taco';
import { t } from '@lingui/macro';
import useCachedQuery from '~/app/shared/hooks/useCachedQuery';
import { EntryType, LegacyDaybook } from '~/types';

export default function PaymentLinkJournalDropdown({ omitJournalCreation, ...props }) {
    const query = useCachedQuery('/daybooks?type=classic', []);

    const handleChange = event => {
        const eventWithNumberValue = { ...event, target: { value: Number(event.detail.value) } };
        props.onChange?.(eventWithNumberValue);
    };

    const paymentLinkAutoCreationJournal = {
        data: null,
        text: t`Betalingslink (New journal created automatically)`,
        value: -999,
    };

    const mappedJournals = query.data.map((journal: LegacyDaybook) => ({
        data: journal,
        text: journal.name,
        value: journal.daybookNumber,
        disabled: journal.entryType !== EntryType.All,
    }));

    const data = omitJournalCreation ? mappedJournals : [paymentLinkAutoCreationJournal, ...mappedJournals];

    return <Select {...props} onChange={handleChange} data={data} loading={query.loading} style={{ width: '130px' }} />;
}
